import { useEffect, useState, useRef } from 'react';
import './App.css';
import './Gallery.css';

function App() {
  const [scrolled, setScrolled] = useState(false);
  const [galleryIndex, setGalleryIndex] = useState(0);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('onas');
  const realizacjeRef = useRef(null);
  const kontaktRef = useRef(null);

  const galleryTiles = [
    { img: '/projekt1.jpg', title: 'Dom jednorodzinny', desc: 'Nowoczesny dom pod Wrocławiem, 2024' },
    { img: '/projekt2.jpg', title: 'Budnynek mieszkalny', desc: 'Budynek mieszkalny, 2023' },
    { img: '/projekt3.jpg', title: 'Dworzec kolejowy', desc: 'Dworzec kolejowy, 2024' },
    { img: '/projekt4.jpg', title: 'Nowoczesny biurowiec', desc: 'Nowoczesny biurowiec, 2025' },
    { img: '/projekt5.jpg', title: 'Dom wielorodzinny', desc: 'Dom wielorodzinny, 2023' },
  ];

  useEffect(() => {
    document.title = "ZRB MAXBUD";
  }, []);

  useEffect(() => {
    let link = document.querySelector("link[rel*='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.type = 'image/png';
    link.href = '/favicon.png'; // Plik w public/favicon.png
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 1);

      const scrollY = window.scrollY;
      const realizacjeTop = realizacjeRef.current?.offsetTop || 0;
      const kontaktTop = kontaktRef.current?.offsetTop || 0;
      if (scrollY + 100 >= kontaktTop) setActiveSection('kontakt');
      else if (scrollY + 100 >= realizacjeTop) setActiveSection('realizacje');
      else setActiveSection('onas');
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (!mobileMenuOpen) return;
    const close = () => setMobileMenuOpen(false);
    window.addEventListener('resize', close);
    return () => window.removeEventListener('resize', close);
  }, [mobileMenuOpen]);

  const handleMenuClick = (section) => {
    setMobileMenuOpen(false);
    let ref = null;
    if (section === 'realizacje') ref = realizacjeRef;
    if (section === 'kontakt') ref = kontaktRef;
    if (ref && ref.current) {
      const y = ref.current.getBoundingClientRect().top + window.scrollY - 200;
      window.scrollTo({ top: y, behavior: 'smooth' });
      setActiveSection(section);
    }
  };

  return (
    <div className="App">
      <header className="header">
        <div className={`navbar ${scrolled ? 'scrolled' : ''}`}>
          <div className="navbar-logo">
            <img src="/logo2.png" alt="Logo" />
          </div>
          <button
            className="navbar-hamburger"
            aria-label="Otwórz menu"
            onClick={() => setMobileMenuOpen(open => !open)}
          >
            <span />
            <span />
            <span />
          </button>
          <nav className={`navbar-menu${mobileMenuOpen ? ' open' : ''}`}>
            <ul>
              <li>
                <a
                  href="#onas"
                  className={activeSection === 'onas' ? 'active' : ''}
                  onClick={e => {
                    e.preventDefault();
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                    setActiveSection('onas');
                    setMobileMenuOpen(false);
                  }}
                >
                  O nas
                </a>
              </li>
              <li>
                <a
                  href="#realizacje"
                  className={activeSection === 'realizacje' ? 'active' : ''}
                  onClick={e => { e.preventDefault(); handleMenuClick('realizacje'); }}
                >
                  Realizacje
                </a>
              </li>
              <li>
                <a
                  href="#kontakt"
                  className={activeSection === 'kontakt' ? 'active' : ''}
                  onClick={e => { e.preventDefault(); handleMenuClick('kontakt'); }}
                >
                  Kontakt
                </a>
              </li>
            </ul>
          </nav>
        </div>
        <div className="header-content">
          <h1 className="header-title">ZRB MAXBUD</h1>
          <div className="header-underline"></div>
          <p className="header-subtitle"></p>
          <div className="holographic-card">
            <h2>Nasze Realizacje</h2>
          </div>
        </div>
      </header>

      <div className="devider"></div>

      <div className="content">
        <div className="Realizacje" id="realizacje" ref={realizacjeRef}>
          <div className="Realizacje-content">
            <h4>Ostatnio Ukończone</h4>
            <h2>Realizacje</h2>
            <p>Przeglądaj nasze dotychczasowe projekty budowlane, które świadczą o naszej jakości i profesjonalizmie.</p>
            <div className="Realizacje-gallery">
              <button
                className="gallery-arrow left"
                aria-label="Poprzednie"
                onClick={() => setGalleryIndex(i => Math.max(i - 1, 0))}
                disabled={galleryIndex === 0}
              >
                ←
              </button>

              <div className="gallery-images" style={{ display: 'flex', gap: '2vw', width: '100%' }}>
                {galleryTiles.slice(galleryIndex, galleryIndex + 3).map((tile, idx) => (
                  <div className="gallery-tile" key={galleryIndex + idx} style={{ flex: '1 1 0', height: '410px', background: 'var(--primary-color)', color: 'var(--secondary-color)' }}>
                    <div className="gallery-tile-img-wrap" style={{ height: '90%' }}>
                      <img src={tile.img} alt={tile.title} className="gallery-tile-img" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                    </div>
                    <div className="gallery-tile-desc" style={{ height: '10%', padding: '0.25rem 0.5rem', textAlign: 'center' }}>
                      <h1 style={{ fontSize: 'clamp(0.8rem, 1.2vw, 1.2rem)', margin: 0 }}>{tile.title}</h1>
                      <p style={{ fontSize: 'clamp(0.7rem, 1vw, 1rem)', margin: 0 }}>{tile.desc}</p>
                    </div>
                  </div>
                ))}
              </div>

              <button
                className="gallery-arrow right"
                aria-label="Następne"
                onClick={() => setGalleryIndex(i => Math.min(i + 1, galleryTiles.length - 3))}
                disabled={galleryIndex >= galleryTiles.length - 3}
              >
                →
              </button>
            </div>
          </div>
        </div>

        <div className="divider"></div>

        <section className="experience-section">
          <h2>Mamy 20 lat doświadczenia w <span>Budownictwie.</span></h2>
          <p className="subtitle"><em>Z naszych profesjonalnych usług skorzystało dziesiątki osób.</em></p>
          <div className="contact-row">
            <span className="phone">+0123456789</span>
            <span className="or">lub</span>
            <a href="#kontakt" className="contact-btn">Skontaktuj się z nami</a>
          </div>
        </section>

        <div className="divider"></div>

        <h2 className="kontakt-header">Kontakt</h2>
        <div className="Kontakt" id="kontakt" ref={kontaktRef}>
          <div className="Kontakt-content">
            <div className="Kontakt-form">
              <h2>Skontaktuj się z nami</h2>
              <form>
                <label htmlFor="name">Imię i Nazwisko:</label>
                <input type="text" id="name" name="name" required />
                <label htmlFor="email">Email:</label>
                <input type="email" id="email" name="email" required />
                <label htmlFor="message">Wiadomość:</label>
                <textarea id="message" name="message" rows="4" required></textarea>
                <button type="submit">Wyślij</button>
              </form>
            </div>
            <div className="Kontakt-loc">
              <div className="Kontakt-loc-map-container">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m14..."
                  title="Mapa Google"
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  className="Kontakt-loc-iframe"
                ></iframe>
              </div>
              <div className="Kontakt-loc-spacer"></div>
            </div>
            <div className="Kontakt-addr">
              <h2>Nasze Biuro</h2>
              <p>ul. Przykładowa 123</p>
              <p>00-000 Miasto</p>
              <p>Telefon: +48 123 456 789</p>
              <p>Email:</p>
            </div>
          </div>
        </div>
      </div>

      <div className="Footer">
        <img src="/logo2.png" alt="Logo" />
      </div>
      <div className="Footer-bar">
        <div className="footer-left">
          ZRB MAXBUD 2025 <br />
          WSZELKIE PRAWA ZASTRZEŻONE
        </div>
        <div className="footer-icons">
          <img src="/ig.png" alt="Instagram" />
          <img src="/fb.png" alt="Facebook" />
          <img src="/yt.png" alt="YouTube" />
        </div>
        <div className="footer-right">
          <a href="/regulamin">REGULAMIN</a>
          <a href="/polityka-prywatnosci">POLITYKA PRYWATNOŚCI</a>
        </div>
      </div>
    </div>
  );
}

export default App;
